import React from "react"
import { Card, CardContent, CardHeader, CardTitle } from "~/shadcn/ui/card"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "~/shadcn/ui/table"

type InfluencerRow = {
  influencerId: string
  influencerName: string
  count: number
}

export const TopInfluencersTable: React.FC<{ data: InfluencerRow[] }> = ({
  data,
}) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium text-gray-500">
          Top Influencers by Request Count
        </CardTitle>
      </CardHeader>
      <CardContent>
        {data.length === 0 ? (
          <div className="flex h-[250px] items-center justify-center text-sm text-gray-400">
            No data for this period
          </div>
        ) : (
          <div className="max-h-[400px] overflow-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead sticky className="w-12">
                    #
                  </TableHead>
                  <TableHead sticky>Influencer</TableHead>
                  <TableHead sticky className="text-right">
                    Requests
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data.map((row, index) => (
                  <TableRow key={row.influencerId}>
                    <TableCell className="text-gray-400">{index + 1}</TableCell>
                    <TableCell>
                      {row.influencerName || `Unknown (${row.influencerId})`}
                    </TableCell>
                    <TableCell className="text-right tabular-nums">
                      {row.count.toLocaleString()}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </CardContent>
    </Card>
  )
}
